import React from 'react'
import '../assets/styles/topnav.css';

const TopnavFooter = () => {
  return (
    <>
      <div className='topnav-footer'>
        <p>Linkedin</p>
        <span><img alt="arrow up" class="nav__footer-icon" src="https://res.cloudinary.com/kadet/image/upload/q_100/v1675899485/petra-portfolio/arrow-up_mity2u.svg" /></span>
      </div>
    </>
  )
}

export default TopnavFooter

